import Wrapper from "./notAllowedToProceedModal.styles";
import {Modal} from "@components/modal";
import React from "react";
import { useSelector } from "react-redux";
import { FooterButtons } from "@components/modal/footerButtons";
import { ModalButton } from "@components/modal/modalButton";
import DOMPurify from 'dompurify';

const RenderFooter = ({action}) => (
  <FooterButtons>
    <ModalButton href={action} rel="noopener">
      Please Continue Here
    </ModalButton>
  </FooterButtons>
);

const NotAllowedToProceedModal = (props) => {
  const { allowedToProceed } = useSelector(state => state.loanForm);
  const { isAllowedToProceed, message, action } = allowedToProceed;
  
  return (
    <Modal
      visible={isAllowedToProceed === false}
      header={
        <span className="title">Welcome back!</span>
      }
      closeable={false}
      size="small"
      footer={action && <RenderFooter action={action} />}
    >
      <Wrapper dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(message)}} />
    </Modal>
  );
};

export default NotAllowedToProceedModal;